/**
 * Top level header for Sales Check-in
 * Contains Cox Bridge Bar and wrappers
 */
// externals
import type { FC } from 'react';
import { useRef } from 'react';

// libraries
import { CoxBridgeBar, RenderWhenOktaEnabled } from '@makemydeal/dr-shared-components';

// styles
import { BridgeBarContainer, BridgeBarHeaderContainer, BridgeBarHeaderRoot, TopBarContainer } from './BridgeBarHeader.style';

const BridgeBarHeader: FC<{ appPrefix: string }> = (props) => {
    const refRoot = useRef<HTMLDivElement | null>(null);

    return (
        <BridgeBarHeaderRoot data-testid="bridge-bar-header-root" ref={refRoot}>
            <BridgeBarHeaderContainer>
                <TopBarContainer>
                    <BridgeBarContainer>
                        <RenderWhenOktaEnabled>
                            <CoxBridgeBar appPrefix={props.appPrefix} />
                        </RenderWhenOktaEnabled>
                    </BridgeBarContainer>
                </TopBarContainer>
            </BridgeBarHeaderContainer>
        </BridgeBarHeaderRoot>
    );
};

export default BridgeBarHeader;
